export default [
  {
    path: '/project/:pid',
    name: 'EdmLayout',
    props: true,
    component: () =>
      import(/* webpackChunkName: "pc-base" */ `@/pc/edm/index.vue`),
    children: [{
      path: 'edm/emaillist',
      name: 'EmailList',
      component: () => import(/* webpackChunkName: "pc-base" */ '@/pc/edm/emailList/Table')
    },
    {
      path: 'edm/send-replort',
      name: 'SendReport',
      component: () => import(/* webpackChunkName: "pc-base" */ '@/pc/edm/emailList/SendReport')
    },
    {
      path: 'edm/detailedlist',
      name: 'DetailedList',
      component: () => import(/* webpackChunkName: "pc-base" */ '@/pc/edm/detailedList/Table')
    },
    {
      path: 'edm/detailedlist/edit/:contactid',
      name: 'EditContactList',
      props: true,
      component: () => import(/* webpackChunkName: "pc-base" */ '@/pc/edm/editContactList/index')
    }]
  }
]
